import React, { useState, useEffect, useRef } from "react";
import { Http } from "../../../../../helpers/axois";
import CodeEditor from "../../../../../helpers/CodeEditor2";
import { useParams, useHistory } from "react-router-dom";
import { AppState } from "../../../../../stateManager/store";
import { useSelector } from "react-redux";
import { useToast, redirectOnError, encodeBase64, decodeBase64, attachCoreTypeDefs } from "../../../../../helpers/commonFunction";
import { Button, Modal } from "../../../../../helpers/commonUi";
import style from './function.module.sass'
import { getFunctions } from "../../forms/create/properties/commonFunctions";
import { ReactComponent as FileIcon } from "../../../../../assets/svg/MarketplaceFunctions/Filedock.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/svg/MarketplaceFunctions/addBtn.svg";
import update from "immutability-helper";
import { Form, Input, Checkbox, Tooltip } from "antd";
import ModalFooter from "../../../../../helpers/commonUi/ModalFooter";
import { initializeA8FormsTypeDefs } from "../../../../../helpers/typedefinitions/a8forms";
import { loadPlugins } from "../../../../../helpers/MicroFrontend";
import { MARKETPLACE_CORE_V3 } from "../../../../../constant/common";
import TarsChatBot from "../../../Assisted/forms/create/properties/TarsChatBot";
import SplitPane, { Pane } from "../../../../../plugin/react-split-pane";
import { ReactComponent as JavaScript } from "../../../../../assets/svg/javascript.svg"
import { ReactComponent as TypeScript } from "../../../../../assets/svg/typescript.svg"
import { ReactComponent as GoBack } from "../../../../../assets/svg/goback.svg"
import { ReactComponent as PermissionSVG } from "../../../../../assets/svg/funcPermission.svg"
import { ReactComponent as LogoPoweredBy } from "../../../../../assets/svg/a8_logo_poweredby.svg"
import { ReactComponent as Logo } from '../../../../../assets/svg/signIn_logos/uniphore-color.svg'
import TarsIcon from "../../../../../assets/images/tarsIcon.png"

const CheckBoxGroup = Checkbox.Group
interface IPermissions {
  a8config: [],
  a8solo: [],
  a8func: [],
  a8gen: []
}
interface IFunction {
  name: string;
  marketplaceInstalledVersion: string;
  marketplaceLatestVersion: string;
  marketplaceId: string;
  source: string;
  comSource: string;
  permissions?: IPermissions;
  release_notes?: string
  id?: string;
  // in marketplace function, `com_source` is the
  // field instead of `comSource`
  com_source?: string;
}

const a8configOptions: string[] = ["getConfig"];
const a8flowClientOptions: string[] = [
  "generateSequenceId",
  "getSessionInfo",
  "sendMail",
  "assignToUser",
  "getSignedURL",
  "nlpService",
  "noOfAvailableAgent",
  "avgQueueWaitTime",
  "businessHoursStatus",
  "getChatTranscript",
  "message",
  "getChatVariables",
  "setChatVariables",
  "deleteChatVariables",
  "getUserVariables",
  "setUserVariables",
  "deleteUserVariables",
];
const a8flowServerOptions: string[] = [
  "generateSequenceId",
  "getSessionInfo",
  "sendMail",
  "assignToUser",
  "getSignedURL",
  "nlpService",
  "noOfAvailableAgent",
  "avgQueueWaitTime",
  "businessHoursStatus",
  "getChatTranscript",
  "message",
  "getChatVariables",
  "setChatVariables",
  "deleteChatVariables",
  "getUserVariables",
  "setUserVariables",
  "deleteUserVariables",
  "dedupe"
];
const a8genOptions: string[] = [
  "summarise",
  "sentimentAnalysis"
]

export default function Create() {
  const [source, setSource] = useState<string>("");
  const [lang, setLang] = useState<any>();
  const [mode, setMode] = useState<string>();
  const params: any = useParams();
  const history: any = useHistory();
  const appId = params.appId;
  const funcId = params.funcId;
  const [functionData, setFunctionData] = useState<IFunction>();
  const [marketplaceFn, setMarketplaceFn] = useState<IFunction>();
  const [resourceLock, setResourceLock] = useState<any>({});
  const [checkoutVisible, setCheckoutVisible] = useState<boolean>(false)
  const [commitVisible, setCommitVisible] = useState<boolean>(false)
  const [isCommit, setIsCommit] = useState(false);
  const [functionsdef, setFunctionsdef] = useState<any>();
  const [updateFnModalVisibility, setUpdateFnModalVisibility] = useState<boolean>(false)
  const [saveFnModalVisibility, setSaveFnModalVisibility] = useState<boolean>(false)
  const [permissionVisible, setPermissionVisible] = useState<boolean>(false)
  const [functionPermission, setFuctionPermission] = useState<IPermissions>();
  const [a8GenPermission, setA8GenPermission] = useState<any[]>([])
  const [configPermission, setConfigPermission] = useState<string[]>([])
  const [a8flowPermission, setA8flowPermission] = useState<any[]>([])
  const [a8funcOptions, setA8funcOptions] = useState<any[]>([])
  const [a8funcPermission, setA8funcPermission] = useState<any>("");
  const [functionList, setFunctionList] = useState<any>([]);
  const [error, setError] = useState('')
  const appversion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[appId]);
  const orgId = useSelector((state: AppState) => (state.org && state.org.selectedOrg && state.org.selectedOrg.id));
  const currentVersion = appversion && appversion.currentVersion;
  const { ErrorToast, SuccessToast, WarningToast } = useToast();
  const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
  })
  const isCheckedIn: boolean = resourceLock.userId === loggedInUserId
  const isUpdateAvailable = functionData && functionData.marketplaceId && (functionData.marketplaceInstalledVersion !== functionData.marketplaceLatestVersion)
  const isMarketplaceFunction = functionData && functionData.marketplaceId;
  const [isPluginsLoaded, setIsPluginsLoaded] = useState(false)

  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const appPermissions: any = useSelector((state: any) => {
    return state.apps.selectedApp.permissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const canEditFunction = currentVersion && (orgPermissions.includes('func.Edit') || appPermissions.includes('func.Edit'))
  const canForceReleaseFunction = orgPermissions.includes('func.ForceReleaseLock') || appPermissions.includes('func.ForceReleaseLock')
  
  useEffect(() => {
    setIsPluginsLoaded(false)
    if (mode === "client") {
      fetchPlugins()
    } else if (mode === "server") {
      setIsPluginsLoaded(true)
    }
  }, [mode])

  function loadCoreV3Plugings() {
    return new Promise(async (res) => {
      await loadPlugins(MARKETPLACE_CORE_V3, "marketplaceCore", () => {
        initializeA8FormsTypeDefs()
        attachCoreTypeDefs(true);
        res("loaded")
      })
    })
  }

  const fetchPlugins = async () => {
    const resp = await loadCoreV3Plugings();
    if (resp) {
      setIsPluginsLoaded(true)
    }
  }

  const version = useSelector(
    (state: any) => state.apps.appVersion[params["appId"]]
  );


  // useEffect(() => {
  //   if((typeof resourceLock.userId !== 'undefined') && (!canEditFunction || !isCheckedIn)) {
  //     WarningToast('Editor is in read-only mode. No authorization to edit this function')
  //   }
  // }, [canEditFunction, WarningToast, resourceLock.userId, isCheckedIn])

  const value: string = `async function main(params) {
  // All deletions and soft deletions happen at the end of code execution
  // Start of editable area

  // End of editable area
}`;

  const getResourceLockData = async () => {
    const versionId = appversion.versionId;
    const data: any = await Http.get(`/apps/${appId}/functions/${funcId}?versionId=${versionId}`).toPromise()
    if (data.length) {
      return data[0].resourceLock
    }
  }

  const getFunction = React.useCallback((discard?: boolean) => {
    if (appversion && appversion.versionId) {
      const versionId = appversion.versionId;
      const navigateTo = `/apps/list/${appId}/functions/list`
      Http.get(`/apps/${appId}/functions/${funcId}?versionId=${versionId}`).subscribe((res: any) => {
        if (res.length) {
          if (res[0].permissions) {
            setFuctionPermission(res[0].permissions);
          } else {
            setFuctionPermission({ a8config: [], a8solo: [], a8func: [], a8gen: [] });
          }
          setMode(res[0].mode);
          setLang(res[0].lang);
          setFunctionData(res[0]);
          setResourceLock(res[0].resourceLock || {})

          if (res[0].source) {
            const values = res[0].source;
            if (values) {
              const regexStr = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
              if (regexStr.test(values)) {
                setSource(values.includes("async") ? values : decodeBase64(values));
                if (editorRef.current && discard) {
                  editorRef.current.setValue(values.includes("async") ? values : decodeBase64(values))
                }
              } else {
                setSource(values);
                if (editorRef.current && discard) {
                  editorRef.current.setValue(values)
                }
              }
            }
          } else {
            setSource(value)
            if (editorRef.current && discard) {
              editorRef.current.setValue(value)
            }
          }
        } else {
          redirectOnError(history, 'no data', navigateTo, "View all functions", "functionId");
        }
      }, (err) => {
        redirectOnError(history, err.message, navigateTo, "View all functions", "functionId");
      })
    }
  }, [appId, funcId, appversion, value, history])

  useEffect(() => {
    getFunction()
  }, [getFunction]);

  const onEditorSave = (editorValue: { source: string; comSource: string }, discard?: boolean) => {
    const data = {
      source: encodeBase64(editorValue.source),
      comSource: encodeBase64(editorValue.comSource),
      appId,
      versionId: appversion.versionId,
      marketplaceId: null,
      marketplaceInstalledVersion: null,
      marketplaceLatestVersion: null,
      permissions: { ...functionPermission, a8func: a8funcOptions },
    };
    Http.put(`/functions/${funcId}?appId=${appId}${isCommit && `&isCommit=true` || `&isCommit=false`}${discard ? '&discard=true':''}`, data).subscribe(
      () => {
        if (isCommit) {
          setCommitVisible(false)
          getFunction(discard)
          SuccessToast('Function commited successfully')
        } else {
          SuccessToast('Function saved successfully')
        }
      },
      (err) => {
        if (isCommit) {
          ErrorToast(`Error commiting function${err.message ? `: ${err.message}` : ""}`)
        } else {
          ErrorToast(`Error saving function${err.message ? `: ${err.message}` : ""}`)
        }
      }
    );
    setIsCommit(false)
  };

  const onClickCommit = async () => {
    const lockData: any = await getResourceLockData()
    if (!lockData.userId) {
      ErrorToast('No one has checked out this resource. Commit Failed!')
      getFunction()
      setIsCommit(false)
    } else if (lockData.userId === loggedInUserId) {
      setCommitVisible(true)
      setIsCommit(true)
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Commit Failed!`)
      setIsCommit(false)
      getFunction()
    }
  }

  const onClickCheckout = async () => {
    const lockData: any = await getResourceLockData()
    if (lockData.userId === loggedInUserId) {
      WarningToast('You have already checkout out this resource!')
      getFunction()
    } else {
      setResourceLock(lockData)
      setCheckoutVisible(true)
    }
  }

  const onClickSave = async () => {
    if (isMarketplaceFunction) {
      return setSaveFnModalVisibility(true)
    }
    const lockData: any = await getResourceLockData()
    if (!lockData.userId) {
      ErrorToast('No one has checked out this resource. Save Failed!')
      getFunction()
    } else if (lockData.userId === loggedInUserId) {
      let modalId: number = 7238210;
      let event = new KeyboardEvent("keydown", {
        key: "s",
        code: "KeyS",
        ctrlKey: true,
        detail: modalId,
      });
      document.dispatchEvent(event);
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Save Failed!`)
      getFunction()
    }
  }

  const onConfirmSaveFunction = async () => {
    const lockData: any = await getResourceLockData()
    if (!lockData.userId) {
      ErrorToast('No one has checked out this resource. Save Failed!')
      getFunction()
    } else if (lockData.userId === loggedInUserId) {
      let modalId: number = 7238210;
      let event = new KeyboardEvent("keydown", {
        key: "s",
        code: "KeyS",
        ctrlKey: true,
        detail: modalId,
      });
      document.dispatchEvent(event);
      setSaveFnModalVisibility(false)
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Save Failed!`)
      getFunction()
    }
  }

  const checkout = () => {
    const versionId = appversion.versionId;
    Http.post(`functions/${funcId}/checkout`, {
      appId,
      versionId: versionId
    }).subscribe(() => {
      SuccessToast(`Function checked out`)
      setCheckoutVisible(false)
      getFunction()
    }, (err) => {
      ErrorToast(`Error checking out function${err.message ? `: ${err.message}` : ""}`)
    })
  }

  const commit = () => {
    let modalId: number = 7238210;
    let event = new KeyboardEvent("keydown", {
      key: "s",
      code: "KeyS",
      ctrlKey: true,
      detail: modalId,
    });
    document.dispatchEvent(event);
  }

  const discard = () => {
    let modalId: number = 7238212;
    let event = new KeyboardEvent("keydown", {
      key: "s",
      code: "KeyS",
      ctrlKey: true,
      detail: modalId,
    });
    document.dispatchEvent(event);
  }

  const forceRelease = () => {
    Http.post(`functions/${funcId}/force-release`, {
      appId,
      versionId: appversion.versionId
    }).subscribe((res) => {
      SuccessToast(`Function force released successfully`)
      getFunction()
      setCheckoutVisible(false)
    }, (err) => {
      ErrorToast(`Error force releasing function${err.message ? `: ${err.message}` : ""}`)
    })
  }

  useEffect(() => {
    const getFunc = async () => {
      let data = await getFunctions(params["appId"], version.versionId);
      setFunctionsdef(data);
    };
    getFunc()
      .catch(console.error)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePermission = () => {
    setPermissionVisible(!permissionVisible)
  }

  const showUpdateFnModal = async () => {
    if (!functionData) {
      return
    }

    try {
      const marketplaceFn = await fetchMarketplaceFn(functionData.marketplaceId)
      setMarketplaceFn(marketplaceFn)
      setUpdateFnModalVisibility(true)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchMarketplaceFn = async (id: string) => {
    if (!functionData) {
      return
    }
    try {
      const endpoint = `/orgs/${orgId}/marketplaceFunctions/${id}`
      const { data: marketplaceFn }: any = await Http.get(endpoint).toPromise()
      return marketplaceFn
    } catch (err) {
      throw new Error(`failed to get marketplace function`)
    }
  }

  const pullUpdatesFromMarketplaceFn = async () => {
    if (!functionData || !marketplaceFn) {
      return
    }

    const payload = {
      versionId: appversion.versionId,
      functionId: functionData.id,
      marketplaceFunctionVersion: functionData.marketplaceLatestVersion,
    };

    const updateFnEndpoint = `/orgs/${orgId}/apps/${appId}/marketplaceFunctions/${functionData.marketplaceId}`
    Http.put(updateFnEndpoint, payload).subscribe(() => {
      setSource(decodeBase64(marketplaceFn.source))
      setUpdateFnModalVisibility(false)
      setFunctionData((prevState: any) => ({
        ...prevState,
        marketplaceInstalledVersion: functionData.marketplaceLatestVersion,
      }))
      SuccessToast(`Function updated successfully`)
    }, (err) => {
      ErrorToast(`Failed to update function${err.message ? `: ${err.message}` : ""}`)
    })
  }

  const addNewFunc = () => {
    if (!a8funcPermission.trim()) {
      setError("Please enter function name")
      return
    }
    const found = functionList.includes(a8funcPermission)
    if (found) {
      setError("Function already exists")
      return
    }
    setFunctionList((prevState: any) => [...prevState, a8funcPermission])
    setA8funcPermission("")
    setTimeout(() => {
      const node = document.getElementById("functionPermissions");
      if (node) {
        node.scrollTop = node.scrollHeight;
      }
    }, 0);
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter' || event.key === "NumpadEnter") {
      addNewFunc()
    }
  }

  useEffect(() => {
    if (functionPermission && Object.keys(functionPermission).length > 0) {
      const { a8config, a8solo, a8func, a8gen } = functionPermission;
      setFunctionList(a8func);
      setA8funcOptions(a8func);
      setConfigPermission(a8config);
      setA8flowPermission(a8solo);
      setA8GenPermission(a8gen);
    }
  }, [functionPermission])

  const [isVisibleTars, setIsVisibleTars] = useState(true);
  const editorRef: any = useRef(null);
  const [currentLine, setCurrentLine] = useState(3)

  return (
    <div style={{ overflow: "hidden", padding: 0, height: "100vh" }} className="viewWrapper">
      <SplitPane className={""} paneStyle={{ width: window.innerWidth + "px" }} >
        <Pane className={' override-component-pane'} minSize={!isVisibleTars ? "100%" : "40%"} initialSize={!isVisibleTars ? "100%" : "60%"} maxSize={!isVisibleTars ? "100%" : "80%"}>
          <div
            className="func_header"
            style={{
              fontSize: "16px",
              textTransform: "capitalize",
            }}
          >
            <div style={{ display: "flex", gap: "7px", alignItems: "center" }}>
              <GoBack onClick={(() => { history.goBack() })}/>
              <span className="func_name">{(functionData && functionData.name)}</span>
              {
                lang === "javascript" ? <JavaScript></JavaScript> : <TypeScript></TypeScript>
              }
              {
                isUpdateAvailable && (
                  <button className={style.updateBtn} onClick={showUpdateFnModal}>
                    Update
                  </button>
                )
              }
            </div>
            <div
              style={{
                display: "flex",
                height: "30px",
                alignItems: "center"
              }}
            >
              <div className={style.fileIcon} style={{ marginRight: '0px', border: "none", background: "none" }} onClick={handlePermission}>
                <PermissionSVG />
              </div>
              {
                isCheckedIn && canEditFunction && (
                  <>
                    <div style={{ marginLeft: '12px' }}>
                      <button className="func_btn_cmt" onClick={onClickCommit}>
                        COMMIT
                      </button>
                    </div>
                    <div style={{ marginLeft: '12px' }}>
                      <button className="func_btn_sve" onClick={onClickSave}>
                        SAVE
                      </button>
                    </div>
                  </>
                )
              }
              {!isVisibleTars && <Tooltip placement="bottom" title={"TARS"} trigger={'hover'}>
                <div className={''} style={{ marginLeft: "12px", display: "flex", alignItems: "center", cursor: "pointer", height: '40px' }} onClick={(() => { setIsVisibleTars(true) })}>
                  <img style={{ height: "33px", width: "33px", objectFit: "contain" }} src={TarsIcon} alt="tars_icon"></img>
                </div>
              </Tooltip>}
              {
                !isCheckedIn && canEditFunction && (
                  <div style={{ marginLeft: '12px' }}>
                    <button className="func_btn_checkout" onClick={onClickCheckout}>CHECKOUT</button>
                  </div>
                )
              }
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ margin: "0", width: permissionVisible ? "calc(100% - 250px)" : "100%", height: window.innerHeight - 120 }}>
              {functionsdef && mode && isPluginsLoaded &&
                <div>
                  <CodeEditor
                    data-test-id="functions_code_editor"
                    minimap={false}
                    value={source || value}
                    height="calc(100vh - 180px)"
                    fontSize={16}
                    type={mode === 'client' ? 'functionClient' : 'functionServer'}
                    lang={lang}
                    onSave={(canEditFunction && isCheckedIn) ? onEditorSave : null}
                    theme="light"
                    readOnly={(!canEditFunction || !isCheckedIn)}
                    customdef={functionsdef}
                    editorRef={editorRef}
                  />
                </div>
              }
            </div>
            {permissionVisible && <div id="functionPermissions" className={style.permissionsPanel} style={{ width: "250px" }}>
              <div className={isCheckedIn && canEditFunction ? "permission-checkbox-group" : "permission-checkbox-group-committed"}>
                <div className={style.permissionsHeader} >
                  Permissions
                </div>
                <div className={style.permissionsTitle}>
                  A8Config
                </div>
                <CheckBoxGroup
                  style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                  options={a8configOptions}
                  value={configPermission}
                  disabled={isCheckedIn && canEditFunction ? false : true}
                  onChange={(value: any) => {
                    setConfigPermission(value);
                    setFuctionPermission(update(functionPermission, {
                      a8config: { $set: value }
                    }))
                  }}
                />
                <hr />
                <div className={style.permissionsTitle}>
                  A8Solo
                </div>
                <CheckBoxGroup
                  style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                  options={mode === 'client' ? a8flowClientOptions: a8flowServerOptions}
                  value={a8flowPermission}
                  disabled={isCheckedIn && canEditFunction ? false : true}
                  onChange={(value: any) => {
                    setA8flowPermission(value)
                    setFuctionPermission(update(functionPermission, {
                      a8solo: { $set: value }
                    }))
                  }}
                />
                <hr />
                {mode === "client" && <div className={style.permissionsTitle}>
                  A8Func
                </div>}
                {mode === "client" && <div className="functions">
                  {isCheckedIn && canEditFunction ?
                    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
                      <Form.Item label="Function Name" className={'a8-form-item props col-md-9'}>
                        <Input
                          type="text"
                          value={a8funcPermission}
                          onChange={(e: any) => setA8funcPermission(e.target.value)}
                          onKeyPress={handleKeyPress}
                          placeholder="Enter name"
                        />
                      </Form.Item>
                      <div>
                        <PlusIcon data-test-id="data_plus_icon" width="28px" height="28px" style={{ marginTop: "8px", cursor: 'pointer' }} onClick={addNewFunc} />
                      </div>
                    </div>
                    : null}
                  {error && <p className={style.errMsg}>{error}</p>}
                  <CheckBoxGroup
                    style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                    options={functionList}
                    value={a8funcOptions}
                    disabled={isCheckedIn && canEditFunction ? false : true}
                    onChange={(value: any) => {
                      setA8funcOptions(value)
                    }}
                  />
                </div>}
                <br />
                <div className={style.permissionsTitle}>
                  A8Gen
                </div>
                <CheckBoxGroup
                  style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                  options={a8genOptions}
                  value={a8GenPermission}
                  disabled={isCheckedIn && canEditFunction ? false : true}
                  onChange={(value: any) => {
                    setA8GenPermission(value)
                    setFuctionPermission(update(functionPermission, {
                      a8gen: { $set: value }
                    }))
                  }}
                />
              </div>
            </div>
            }
          </div>
          <div style={{ width: "100%", height: "70px", display: "flex", alignItems: "center", paddingLeft: "10px", borderTop: "1px solid #D9D9D9" }}>
            {/* <LogoPoweredBy /> */}
            <p style={{ marginBottom: 0, width: 80 }}>Powered By</p>
            <Logo />
          </div>
        </Pane>
        {isVisibleTars &&
          <Pane className={' override-component-pane'} minSize="30%" initialSize="40%" maxSize="60%">
            <TarsChatBot editorRef={editorRef} type={mode === 'client' ? 'clientFn' : 'serverFn'} currentLine={currentLine} setIsVisibleTars={setIsVisibleTars} ></TarsChatBot>
          </Pane>
        }
      </SplitPane>

      <Modal
        id='checkoutModal'
        dataTestId='checkoutModal'
        title={!resourceLock.userId ? "CHECKOUT" : "WARNING"}
        visible={checkoutVisible}
        onCancel={() => {
          setCheckoutVisible(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: true,
          okText: !resourceLock.userId ? "CHECKOUT" : canForceReleaseFunction ? "FORCE RELEASE" : "OK",
          cancelText: "CANCEL",
          onOk: () => {
            if (!resourceLock.userId) {
              checkout()
            } else if (canForceReleaseFunction) {
              forceRelease()
            } else {
              setCheckoutVisible(false)
            }
          }
        }}
      >
        {
          !resourceLock.userId ?
            <>
              <div className={style.modalMsg}>
                Do you want to checkout ?
              </div>
              <div className={style.note}>
                Note: This will prevent others from editing this resource until you commit
              </div>
            </>
            :
            <>
              <div className={style.modalMsg}>
                <span className={style.modalHighlightedMsg}>{resourceLock.userName}</span> has currently checked out this resource
              </div>
              {
                canForceReleaseFunction &&
                <>
                  <div className={style.modalMsg}>
                    Do you want to force release ?
                  </div>
                  <div className={style.note}>
                    Note: This will revoke editing access from the currently checked out user.
                  </div>
                </>
              }
            </>
        }
      </Modal>
      <Modal
        id='commitModal'
        dataTestId='commitModal'
        title="COMMIT"
        visible={commitVisible}
        onCancel={() => {
          setCommitVisible(false)
          setIsCommit(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: false,
        }}
      >
        {
          <>
            <div className={style.modalMsg}>
              Do you wish to commit ?
            </div>
            <ModalFooter okText="SAVE & COMMIT" cancelText="DISCARD & COMMIT" okCallback={commit} cancelCallback={discard} cancelClassName="discard_btn" />
          </>
        }
      </Modal>
      <Modal
        id="updateFunction"
        unmountOnCancel
        visible={updateFnModalVisibility}
        title="UPDATE FUNCTION"
        onCancel={() => setUpdateFnModalVisibility(false)}
        footer={{
          enable: true,
          okText: 'UPDATE',
          cancelText: 'CANCEL',
          onOk: pullUpdatesFromMarketplaceFn,
        }}
      >
        <div className={style.modalMsg}>
          <p>Are you sure you want to pull updates from marketplace function?</p>
          {marketplaceFn && marketplaceFn.release_notes && (
            <div>
              <p style={{ margin: 0, color: "#3461A2" }}>Release Notes</p>
              <span>{marketplaceFn.release_notes}</span>
            </div>
          )}
        </div>
      </Modal>
      <Modal
        id="saveFunction"
        unmountOnCancel
        visible={saveFnModalVisibility}
        title="SAVE FUNCTION"
        onCancel={() => setSaveFnModalVisibility(false)}
        footer={{
          enable: true,
          okText: 'SAVE',
          cancelText: 'CANCEL',
          onOk: onConfirmSaveFunction,
        }}
      >
        <div className={style.modalMsg}>
          <p>This function will now be treated as A8 function. Are you sure you want to save?</p>
        </div>
      </Modal>
    </div>
  );
};
